import { Pipe, PipeTransform } from '@angular/core';
import { select } from '@ngxs/store';
import { FeatureName } from '@wilson/interfaces';
import { PermissionsState } from '../state/permissions.state';

@Pipe({
  name: 'featureSignal',
  standalone: true,
  pure: false,
})
export class FeatureSignalPipe implements PipeTransform {
  // Must stay a field initializer: NGXS select() calls inject(Store).
  // Calling select() inside transform() breaks when used from computed().
  private readonly features = select(PermissionsState.featurePermissions);

  transform(value: FeatureName): boolean {
    return this.features().includes(value);
  }
}
